"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapMoveOutQueryKapiToMoveOutCX = exports.formatSupplyPointAddress = void 0;
var date_fns_1 = require("date-fns");
var __generated__1 = require("../../../../shared/api/kapi/v1/__generated__/");
var utils_1 = require("../../utils");
var formatSupplyPointAddress = function (_a) {
    var addressLines = _a.addressLines, postCode = _a.postCode;
    return addressLines && postCode ? __spreadArray(__spreadArray([], __read(addressLines), false), [postCode], false).join(', ') : null;
};
exports.formatSupplyPointAddress = formatSupplyPointAddress;
var mapMoveOutQueryKapiToMoveOutCX = function (data) {
    if (!data || !data.account || !data.account.accountSupplyPoints) {
        return null;
    }
    // At least one customer linked to the account that is financially liable and
    // does not have "POST" as their primary comms preference.
    // See https://github.com/ovotech/homemoves-public-api/blob/master/src/services/move-out-request/validate-move-out.ts#L110
    var canSelfServe = data.account.customerAccountRelationships.edges.some(function (_a) {
        var _b = _a.node, roles = _b.roles, commsPreference = _b.commsPreference;
        return roles &&
            roles.includes(__generated__1.CustomerAccountRole_NextV1.FinanciallyLiable) &&
            commsPreference &&
            commsPreference[0] !== __generated__1.CommunicationChannel.Post;
    });
    var moveOutDate = data.account.accountSupplyPoints.reduce(function (acc, asp) {
        //ASP (in Kapi) records the customer-selected move out date as exclusive i.e. the move out date it returns is the day before the one selected by the customer
        return asp.end && asp.end.reason === 'MoveOut'
            ? (0, date_fns_1.format)((0, date_fns_1.addDays)(asp.end.date, 1), 'yyyy-MM-dd')
            : acc;
    }, null);
    var supplyPointAddress = data.account.accountSupplyPoints.reduce(function (acc, asp) { return asp.supplyPoint.address || acc; }, null);
    var formattedAddress = supplyPointAddress
        ? (0, exports.formatSupplyPointAddress)(supplyPointAddress)
        : null;
    var hasSubmittedFinalReads = !moveOutDate
        ? false
        : data.account.accountSupplyPoints.every(function (_a) {
            var meterReads = _a.meterReads;
            return meterReads.edges.some(function (_a) {
                var _b = _a.node, reading = _b.reading, __typename = _b.__typename;
                return __typename === 'ValidReading' &&
                    reading.type !== __generated__1.ReadingType.Estimate &&
                    (0, utils_1.readingAfterOrEqual)(reading.dateTime, moveOutDate);
            });
        });
    return {
        canSelfServe: canSelfServe,
        moveOutDate: moveOutDate,
        formattedAddress: formattedAddress,
        hasSubmittedFinalReads: hasSubmittedFinalReads,
    };
};
exports.mapMoveOutQueryKapiToMoveOutCX = mapMoveOutQueryKapiToMoveOutCX;
